import axios from 'axios';
import { getToken } from './auth';
const querystring = require('querystring');
export default function downloadStreamFile(url, data, fileName) {
  return axios({
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'post',
    url: url,
    data: querystring.stringify(data),
    responseType: 'blob',
    headers: { Authorization: getToken() }
  })
    .then(response => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
      });
      const downloadElement = document.createElement('a');
      const href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = `${fileName}.xlsx`; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    })
    .catch(() => {});
}
